import React, { useCallback, useState, useEffect, useRef } from "react"
import { useHistory } from "react-router-dom"
import Form from "@bappweb/form"
import Panel from "@bappweb/panel"
import TextField from "@bappweb/textfield"
import Button from "@bappweb/button"
import Checkbox from "@bappweb/checkbox"
import Link from "@bappweb/link"
import Captcha from "@smpu-web/nested/form/captcha"
import FormMessage from "@smpu-web/globalmodules/form-message/index"
import Page from "@smpu-web/globalmodules/page"
import Element from "@bappweb/element"
import { dateFormat, numeric, RegexpTypes, required } from "@bappweb/utils"
import {
  useGetTokenByTckn1Mutation,
  useGetCaptchaMutation,
  useRefreshCaptchaMutation,
  useApplyMutation
} from "../../../api/service"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"
import { getDayMonthYearFromStr } from "../../../../../utils/utils"

function MainForm() {
  const history = useHistory()

  const getCid = () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);

    return params.get('cid') ?? "AkbOrgnc"
  }

  const [captchaValues, setCaptchaValues] = useState({
    tokenSessionId: "",
    captchaData: "",
    captcha: "",
    showCaptcha: false,
    captchaValidate: true
  })

  const [formValues, setFormValues] = useState({
    tckn: "",
    birthdate: "",
    phone: ""
  })

  const [error, setError] = useState<string | null>(null)
  const [isFetching, setIsFetching] = useState(false)
  const refForm = useRef(null)
  const [getTokenByTckn1] = useGetTokenByTckn1Mutation()
  const handleChange = useCallback(
    (e) => {
      const name = e.target.name
      const value = e.target.value

      switch (name) {
        case "tckn":
          setError(null)
          setFormValues({
            ...formValues,
            tckn: value
          })
          setCaptchaValues({
            ...captchaValues,
            captchaData: "",
            tokenSessionId: "",
            showCaptcha: false
          })

          // @ts-ignore TODO
          // Captcha alanı temizlendiğinde validasyon hatası alıyor. O nedenle bu şekilde alanı temizliyoruz.
          refForm.current?.setValue("captcha", "")

          if ((value ?? "").length === 11) {
            setIsFetching(true)
            getTokenByTckn1(value)
              .unwrap()
              .then((payload) => {
                if (!payload.IsError) {
                  setError("")
                  setCaptchaValues({
                    ...captchaValues,
                    tokenSessionId: payload.tokenSessionId
                  })
                } else {
                  setError(payload.ErrorMessage ? payload.ErrorMessage : "")
                }
              })
              .finally(() => {
                setIsFetching(false)
              })
          }
          break
        case "birthdate":
          setError(null)
          setFormValues({
            ...formValues,
            birthdate: value
          })
          break
        case "phone":
          setError(null)
          setFormValues({
            ...formValues,
            phone: value
          })
          break
        case "captcha":
          setError(null)
          setCaptchaValues({
            ...captchaValues,
            captcha: value
          })
          break
        default:
          break;
      }
    },
    [formValues, getTokenByTckn1, captchaValues]
  )

  const [getCaptcha] = useGetCaptchaMutation()
  useEffect(() => {
    if (captchaValues.captchaData === "" && captchaValues.tokenSessionId !== "") {
      setIsFetching(true)
      getCaptcha({
        tckn: formValues.tckn,
        TokenSessionId: captchaValues.tokenSessionId
      })
        .unwrap()
        .then((payload) => {
          if (!payload.IsError) {
            setCaptchaValues({
              ...captchaValues,
              captchaData: payload.captchaData,
              showCaptcha: true,
              captchaValidate: true
            })
          } else {
            setError(payload.ErrorMessage ? payload.ErrorMessage : "")
          }
        })
        .finally(() => {
          setIsFetching(false)
        })
    }
  }, [formValues, getCaptcha, captchaValues])

  const [refreshCaptcha] = useRefreshCaptchaMutation()
  const handleCaptchaRefresh = useCallback(() => {
    setIsFetching(true)
    refreshCaptcha({
      tckn: formValues.tckn,
      TokenSessionId: captchaValues.tokenSessionId
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setCaptchaValues({
            ...captchaValues,
            captchaData: payload.captchaData,
            captchaValidate: true
          })
        } else {
          setError(payload.ErrorMessage ? payload.ErrorMessage : "")
        }
      })
      .finally(() => {
        setIsFetching(false)
      })
  }, [formValues, captchaValues, refreshCaptcha])

  const [apply] = useApplyMutation()
  const handleSubmit = useCallback(
    (e?: React.BaseSyntheticEvent, values?: Record<string, any>) => {
      if (values && captchaValues.captcha !== "") {
        setIsFetching(true)
        const parsedBirthDate = getDayMonthYearFromStr(values.birthdate)
        apply({
          tckn: formValues.tckn,
          dogumYil: parsedBirthDate.year,
          dogumAy: parsedBirthDate.month,
          dogumGun: parsedBirthDate.day,
          cepTel: "0090" + values.phone.replace(/\s/g, ''),
          cid: getCid(),
          captcha: captchaValues.captcha.toUpperCase(),
          kvkk: values.checkboxKvkk,
          etk: true,
          TokenSessionId: captchaValues.tokenSessionId
        })
          .unwrap()
          .then((payload) => {
            if (!payload.IsError) {
              setError(null)
              history.push("/details/smsotp")
            } else {
              setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              window.scrollTo({
                top: 0
              })
              refreshCaptcha({
                tckn: formValues.tckn,
                TokenSessionId: captchaValues.tokenSessionId
              })
                .unwrap()
                .then((payload) => {
                  if (!payload.IsError) {
                    setCaptchaValues({
                      ...captchaValues,
                      captcha: "",
                      showCaptcha: true,
                      captchaData: payload.captchaData,
                      captchaValidate: false
                    })
                  } else {
                    setError(payload.ErrorMessage ? payload.ErrorMessage : "")
                  }
                })
                .finally(() => {
                  setIsFetching(false)
                })
            }
          })
          .finally(() => {
            setIsFetching(false)
          })
      }
    },
    [captchaValues, formValues, apply, refreshCaptcha, history]
  )

  return (
    <Page>
      <Form onSubmit={handleSubmit} onChange={handleChange} grid={false} ref={refForm}>
        <Panel hasFooter connected={false}>
          <FormMessage className={"form-msg-error"} error={error}></FormMessage>
          <Panel.Body>
            <Element type="h1" className="bapp-panel-body-card-description">
              Kredi Kartı İşsizlik Sigortası Başvurusu
            </Element>
            <TextField
              label="TC Kimlik Numarası"
              type="number"
              name="tckn"
              placeholder="TC Kimlik Numarası"
              maxLength={11}
              value={formValues.tckn}
              validator={RegexpTypes.Numeric}
              validations={[required("Lütfen TC Kimlik Numaranızı giriniz."), numeric()]}
            />
            <TextField
              label='Doğum Tarihi'
              type="text"
              placeholder="GG.AA.YYYY"
              mask="99.99.9999"
              name="birthdate"
              maxLength={10}
              validations={[
                required("Doğum Tarihi alanı zorunludur."),
                dateFormat("Lütfen Geçerli Bir Tarih Giriniz")
              ]}
            />
            <TextField
              label="Cep Telefon No"
              type="text"
              name="phone"
              placeholder="5__ ___ __ __"
              mask="999 999 99 99"
              maxLength={13}
              getMaskedValue={true}
              validations={[required("Lütfen Telefon Numaranızı giriniz.")]}
            />
            {captchaValues.showCaptcha && (
              <Captcha
                label="Güvenlik Kodu"
                id="captcha"
                type="text"
                name="captcha"
                placeholder="Güvenlik Kodu"
                captcha={captchaValues.captchaData}
                value={captchaValues.captcha}
                maxLength={4}
                maxRefreshCount={3}
                refreshClick={handleCaptchaRefresh}
                validations={[required("Lütfen güvenlik kodunu giriniz.")]}
              />
            )}
            <div className="checkbox-group">
              <Checkbox
                className="cb-position-fix"
                name="checkboxKvkk"
                validations={[required("Lütfen onay kutusunu işaretleyiniz.")]}
                validateOnSubmit={true}
                block>
                {"AKBANK T.A.Ş. olarak kişisel verilerini önemsiyoruz. 6698 nolu Kişisel Verilerin Korunması Kanunu kapsamında kişisel verilerinin işlenmesinden doğan haklarına ve bu konudaki detaylı bilgiye "}
                <Link
                  href="//www.akbank.com/Documents/KISISELVERILERINKORUNMASI_TR.pdf"
                  text={"aydınlatma metninden"}
                  inline
                  target="_blank"
                />
                {" ulaşabilirsin."}
              </Checkbox>
            </div>
          </Panel.Body>
          <Panel.Footer>
            <Panel.RightFooter>
              <Button text="Gönder" type="submit" fetching={isFetching} disabled={isFetching} />
            </Panel.RightFooter>
          </Panel.Footer>
        </Panel>
      </Form>
    </Page>
  )
}

export default MainForm
